import Home from "./pages/Home";
import { ChatContextProvider } from "./context/chatContext";
import Admin from "./pages/Admin";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./pages/AdminLogin";
import Login from "./pages/Login";

const App = () => {
  return (
    <ChatContextProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/adminlogin" element={<AdminLogin />} />
        </Routes>
      </Router>
    </ChatContextProvider>
  );
};

export default App;

